import React from "react";
import { Circle } from "react-konva";

import { Point } from "./types";

// rendered radius for a resize control
export const RESIZE_RADIUS = 8;

interface IProps {
  readonly center: Point;
}
export const ZoneResizeControl = ({ center }: IProps) => (
  <Circle fill="lightgray" stroke="black" {...center} radius={RESIZE_RADIUS} />
);
